var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "140px"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "区域名称", prop: "areaId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            filterable: "",
                            clearable: "",
                            placeholder: "请选择区域名称"
                          },
                          on: { change: _vm.changeArea },
                          model: {
                            value: _vm.childData.areaId,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "areaId", $$v)
                            },
                            expression: "childData.areaId"
                          }
                        },
                        _vm._l(_vm.companyList, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.areaName, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "闭馆维修开始日期", prop: "startTime" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          clearable: "",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd",
                          type: "date",
                          placeholder: "请选择订场开始日期"
                        },
                        model: {
                          value: _vm.childData.startTime,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "startTime", $$v)
                          },
                          expression: "childData.startTime"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "闭馆维修结束日期", prop: "endTime" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          clearable: "",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd",
                          type: "date",
                          placeholder: "请选择订场结束日期"
                        },
                        model: {
                          value: _vm.childData.endTime,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "endTime", $$v)
                          },
                          expression: "childData.endTime"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "订场时间", prop: "week" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "200px" },
                          attrs: {
                            clearable: "",
                            placeholder: "请选择订场时间"
                          },
                          model: {
                            value: _vm.childData.week,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "week", $$v)
                            },
                            expression: "childData.week"
                          }
                        },
                        _vm._l(_vm.statusOptions, function(item) {
                          return _c("el-option", {
                            key: item.dicValue,
                            attrs: { label: item.dicName, value: item.dicValue }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "场地", prop: "placeIdList" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            disabled: _vm.childData.areaId ? false : true,
                            filterable: "",
                            multiple: "",
                            clearable: "",
                            placeholder: "请选择场地"
                          },
                          on: { change: _vm.changePlace },
                          model: {
                            value: _vm.childData.placeIdList,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "placeIdList", $$v)
                            },
                            expression: "childData.placeIdList"
                          }
                        },
                        _vm._l(_vm.placeOptions, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.placeName, value: item.id }
                          })
                        }),
                        1
                      ),
                      !_vm.childData.areaId
                        ? _c(
                            "span",
                            {
                              staticStyle: { color: "red", "font-size": "12px" }
                            },
                            [_vm._v("* 请先选择区域名称")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "时间段", prop: "periodName" } },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-input", {
                            staticClass: "mytextarea",
                            staticStyle: {
                              width: "100%",
                              "min-height": "36px !important"
                            },
                            attrs: {
                              type: "textarea",
                              readonly: "",
                              autosize: "",
                              resize: "none",
                              placeholder: "请选择时间段"
                            },
                            model: {
                              value: _vm.childData.periodName,
                              callback: function($$v) {
                                _vm.$set(_vm.childData, "periodName", $$v)
                              },
                              expression: "childData.periodName"
                            }
                          }),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                width: "90px",
                                "margin-left": "10px",
                                height: "36px"
                              },
                              attrs: { icon: "el-icon-search" },
                              on: { click: _vm.choosePlace }
                            },
                            [_vm._v("选择")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          maxlength: "200",
                          type: "textarea",
                          placeholder: "请输入备注",
                          autosize: { minRows: 3, maxRows: 3 }
                        },
                        model: {
                          value: _vm.childData.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "remark", $$v)
                          },
                          expression: "childData.remark"
                        }
                      }),
                      _c(
                        "span",
                        { staticStyle: { color: "red", "font-size": "12px" } },
                        [
                          _vm._v(
                            "* 闭馆维修优先级高于长期订场，如果二者时间有交叉，以闭馆维修为准"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择",
            visible: _vm.dialogFormVisible,
            width: "800px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c("chooseTime", {
            attrs: {
              "key-value": _vm.childData.areaId,
              periodIdList: _vm.periodIdList,
              "show-dialog": _vm.dialogFormVisible
            },
            on: {
              handCancle: _vm.handCancleTime,
              handCreate: _vm.handCreateTime
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }